module.exports = __webpack_public_path__ + "static/EverForward3-63018852adc705897b8c3af168ee5020.webp";